import { SET_SGIP_IS_VISIBLE } from './constants';

const defaultState = { isVisible: false };

const sgipUI = (state = defaultState, action) => {
    switch (action.type) {
        case SET_SGIP_IS_VISIBLE:
            return { ...state, isVisible: action.isVisible };

        default:
            return state;
    }
};

export default sgipUI;



// WEBPACK FOOTER //
// ./src/containers/Inputs/SGIP/reducer.js